import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP6ChurnedReorder202606: FaireAdPerformancePeriodEntity = {
  token: "perf_p6_churned_reorder_202606",
  type: "adPerformancePeriod",
  scope: "REORDER_MARKETPLACE",
  periodType: "RECEIPT",
  startDate: "2026-06-01",
  endDate: "2026-06-30",
  impressions: 3049,
  clicks: 65,
  adsSpendDollars: 276,
  budgetDollars: 600,
  salesDollars: 2422,
  bestEstimateRoas: 8.78,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 0.46,
  reorderConversions: 6,
  dataAvailableAtDate: "2026-07-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
